module.exports = __webpack_public_path__ + "img/3.706212b4.jpg";